var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCbinsights = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.224,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    fillRule: "evenodd",
    d: "M10.656 12.376h3.882V8.314H8.125a1.64 1.64 0 0 0-1.64 1.642v5.68a1.64 1.64 0 0 0 1.64 1.631h6.413V13.16h-3.882zm8.629 0h-3.993V8.314h2.346a1.64 1.64 0 0 1 1.639 1.642zm0 3.26V13.16h-3.993v4.107h2.346a1.64 1.64 0 0 0 1.639-1.639",
    clipRule: "evenodd"
  })));
};
export default SvgCbinsights;